export const generateMarginClasses = (margin) => {
  if (margin) {
    console.warn(
      'Warning: The "margin" property is deprecated and will be removed in a future release. Please use an alternative solution.'
    )
  }

  if (typeof margin === 'string' && margin == 'none') {
    return `mnone`
  }

  const spacingScale = {
    xxxs: "xxxs",
    xxs: "xxs",
    xs: "xs",
    s: "s",
    m: "m",
    l: "l",
    xl: "xl",
    xxl: "xxl",
    xxxl: "xxxl",
  }

  if (typeof margin === 'string') {
    // Uniform margin case e.g., margin="xs"
    return `m${spacingScale[margin]}`
  }

  if (typeof margin === 'object') {
    const marginClasses = []

    // Loop through the object and map to classes
    if (margin.top) {
      marginClasses.push(`mt${spacingScale[margin.top]}`)
    }
    if (margin.bottom) {
      marginClasses.push(`mb${spacingScale[margin.bottom]}`)
    }
    if (margin.left) {
      marginClasses.push(`ml${spacingScale[margin.left]}`)
    }
    if (margin.right) {
      marginClasses.push(`mr${spacingScale[margin.right]}`)
    }
    if (margin.horizontal) {
      marginClasses.push(`mh${spacingScale[margin.horizontal]}`)
    }
    if (margin.vertical) {
      marginClasses.push(`mv${spacingScale[margin.vertical]}`)
    }

    return marginClasses.join(" ")
  }

  return "" // If no margin is provided
}

export const generatePaddingClasses = (padding) => {
  if (padding) {
    console.warn(
      'Warning: The "padding" property is deprecated and will be removed in a future release. Please use an alternative solution.'
    )
  }

  if (typeof padding === 'string' && padding == 'none') {
    return `pnone`
  }

  const spacingScale = {
    xxxs: "xxxs",
    xxs: "xxs",
    xs: "xs",
    s: "s",
    m: "m",
    l: "l",
    xl: "xl",
    xxl: "xxl",
    xxxl: "xxxl",
  }

  if (typeof padding === 'string') {
    // Uniform padding case e.g., padding="xs"
    return `p${spacingScale[padding]}`
  }

  if (typeof padding === 'object') {
    const paddingClasses = []

    // Loop through the object and map to classes
    if (padding.top) {
      paddingClasses.push(`pt${spacingScale[padding.top]}`)
    }
    if (padding.bottom) {
      paddingClasses.push(`pb${spacingScale[padding.bottom]}`)
    }
    if (padding.left) {
      paddingClasses.push(`pl${spacingScale[padding.left]}`)
    }
    if (padding.right) {
      paddingClasses.push(`pr${spacingScale[padding.right]}`)
    }
    if (padding.horizontal) {
      paddingClasses.push(`ph${spacingScale[padding.horizontal]}`)
    }
    if (padding.vertical) {
      paddingClasses.push(`pv${spacingScale[padding.vertical]}`)
    }

    return paddingClasses.join(" ")
  }

  return "" // If no padding is provided
}

export const generateSpacingClasses = (padding, margin) => {
  const spacingClasses = []

  if (padding) {
    spacingClasses.push(generatePaddingClasses(padding))
  }
  if (margin) {
    spacingClasses.push(generateMarginClasses(margin))
  }

  return spacingClasses.join(" ")
}
